import { render, staticRenderFns } from "./bulma_field.vue?vue&type=template&id=593c36a1&scoped=true&lang=html"
import script from "./bulma_field.vue?vue&type=script&lang=js"
export * from "./bulma_field.vue?vue&type=script&lang=js"
import style0 from "./bulma_field.vue?vue&type=style&index=0&id=593c36a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "593c36a1",
  null
  
)

export default component.exports